/* Menu façon "Concept" — duplique le libellé pour le roll-text et
   ajoute l'effet magnétique. Desktop pointeur fin uniquement.
   En cas d'échec : le menu reste le Dawn d'origine. */
(function () {
  if (!window.matchMedia) return;
  var fine = matchMedia('(pointer: fine)').matches;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduce) return;

  var esc = function (s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  var spans = document.querySelectorAll(
    '.header__inline-menu > ul > li > a.header__menu-item > span,' +
    '.header__inline-menu > ul > li details > summary.header__menu-item > span'
  );

  spans.forEach(function (span) {
    var txt = span.textContent.trim();
    if (txt && !span.querySelector('.cm-roll')) {
      span.innerHTML =
        '<span class="cm-roll"><span class="cm-a">' + esc(txt) +
        '</span><span class="cm-b" aria-hidden="true">' + esc(txt) + '</span></span>';
    }
    var el = span.closest('a, summary');
    if (!el) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var dx = (e.clientX - r.left - r.width / 2) * 0.12;
      var dy = (e.clientY - r.top - r.height / 2) * 0.22;
      el.style.setProperty('--cm-x', Math.max(-6, Math.min(6, dx)) + 'px');
      el.style.setProperty('--cm-y', Math.max(-4, Math.min(4, dy)) + 'px');
    });
    el.addEventListener('pointerleave', function () {
      el.style.setProperty('--cm-x', '0px');
      el.style.setProperty('--cm-y', '0px');
    });
  });
})();
